// src/components/Careers/OpenPositions/OpenPositions.js
import React from 'react';
import './OpenPositions.css';

const jobs = [
    { title: 'Account Executive', department: 'Sales', location: 'Singapore, North West, Singapore' },
    { title: 'Account Executive', department: 'Sales', location: 'San Mateo, California, United States' },
    { title: 'Enterprise Account Executive', department: 'Sales', location: 'Remote, US' },
    { title: 'Enterprise Account Executive', department: 'Sales', location: 'London, England, United Kingdom' },
    { title: 'Field Marketing Manager, APAC', department: 'Marketing', location: 'Singapore, North West, Singapore' },
    { title: 'Field Marketing Manager, APAC', department: 'Marketing', location: 'Seoul, South Korea' },
    { title: 'Forward Deployed Engineer', department: 'Product', location: 'San Mateo, California, United States' },
    { title: 'Forward Deployed Product Manager', department: 'Product', location: 'Seoul, South Korea' },
    { title: 'Head of Sales, APAC', department: 'Sales', location: 'Seoul, South Korea' },
    { title: 'People, Development, and Experience Partner (HRBP)', department: 'People and Culture', location: 'San Mateo, California, United States' },
    { title: 'Product Manager, AI Agent', department: 'Product', location: 'Seoul, South Korea' },
    { title: 'Software Engineer, Client Javascript', department: 'Engineering', location: 'Seoul, South Korea' },
    { title: 'Software Engineer, Data Infrastructure', department: 'Engineering', location: 'Seoul, South Korea' },
    { title: 'Solutions Architect (Pre and Post Sales)', department: 'Customer Success', location: 'London, England, United Kingdom' }
];


function OpenPositions() {
  return (
    <section className="jobs-section">
      <div className="jobs-container">
        <h2 className="jobs-heading">Open Positions</h2>
        <p className="jobs-subheading">We are hiring across locations including our HQ in San Mateo, California and our Asia HQ in Seoul, Korea, where we were founded. We also have teams in London, Singapore, and India.</p>
        <div className="jobs-listing">
          <div className="jobs-header">
            <div className="header-title">Job Title</div>
            <div className="header-department">Department</div>
            <div className="header-location">Location</div>
          </div>
          <div className="jobs-list">
            {jobs.map((job, index) => (
              <div className="job-row" key={index}>
                <div className="job-title">{job.title}</div>
                <div className="job-department">{job.department}</div>
                <div className="job-location">{job.location}</div>
                <a href="#" className="job-apply-button">Apply Now</a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OpenPositions;